module.exports = __webpack_public_path__ + "static/img/product2.a8714d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/product2.png
// module id = Xjoq
// module chunks = 1